import React from 'react';

import styles from 'components/MapLegend/CustomLegend.module.scss';

const CustomLegend = ({ items = [] }) => (
  <React.Fragment>
    <ul className={styles.colorBar}>
      {items.map(item => (
        <li
          key={JSON.stringify(item)}
          className={styles.colorBarItem}
          style={{ background: item.color }}
          title={item.label}
        >
          <span className={styles.srOnly}>
            {item.label}
          </span>
        </li>
      ))}
    </ul>
    <ul className={styles.extentBar}>
      {[items[0], ...items.slice(-1)].map(item => (
        <li
          key={JSON.stringify(item)}
          className={styles.extentBarItem}
        >
          {item.label}
        </li>
      ))}
    </ul>
  </React.Fragment>
);

export default CustomLegend;



// WEBPACK FOOTER //
// ./src/components/MapLegend/CustomLegend.js